import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=3f10bebf&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"
import style0 from "./Column.vue?vue&type=style&index=0&id=3f10bebf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10bebf",
  null
  
)

export default component.exports